import { call, put, takeLatest } from "redux-saga/effects";
import { actionTypes as profileActionTypes } from "./reducer";
import { whoami as serviceGetProfile } from "./service";
import { message } from "antd";

function* getProfile(action) {
  try {
    const profile = yield call(serviceGetProfile);

    yield put({
      type: profileActionTypes.GET_PROFILE_REQUEST_SUCCESS,
      profile
    });
  } catch (err) {
    yield put({ type: profileActionTypes.GET_PROFILE_REQUEST_FAILED, err });

    message.error("Failed to get profile");
  }
}

function* watchGetProfileRequest() {
  yield takeLatest(profileActionTypes.GET_PROFILE_REQUEST, getProfile);
}

export default [watchGetProfileRequest()];



// WEBPACK FOOTER //
// ./src/modules/profile/saga.js